import * as React from 'react';
import type { SVGProps } from 'react';

const IconSquareQuote = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69 66" {...props}>
    <g clipPath="url(#IconSquareQuote)">
      <path
        d="M27.77 65.4H.79V36.702L17.96.4h8.584L16.487 38.419H27.77v26.98Zm40.963 0H41.752V36.702L58.922.4h8.584L57.45 38.419h11.283v26.98Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="IconSquareQuote">
        <path fill="#fff" transform="translate(-15 -3324)" d="M0 0h390v6256H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default IconSquareQuote;
